import { render, staticRenderFns } from "./AdminGeneralEligibilities.vue?vue&type=template&id=7354bd58&scoped=true"
import script from "./AdminGeneralEligibilities.vue?vue&type=script&lang=js"
export * from "./AdminGeneralEligibilities.vue?vue&type=script&lang=js"
import style0 from "./AdminGeneralEligibilities.vue?vue&type=style&index=0&id=7354bd58&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7354bd58",
  null
  
)

export default component.exports